<p-confirmDialog />
<mi-interactive-toast />
<mi-layout [navCollapsed]="navCollapsed()" [class.embedded]="isEmbedded">
  @if (!isEmbedded) {
    <ng-container navigation>
      <mi-navigation appName="Mitel" [items]="navItems" [(mini)]="navCollapsed" />
    </ng-container>
  }
  <ng-container header>
    <p-toolbar class="flex-nowrap w-full rounded-none border-0 border-b border-solid border-surface py-2 px-4">
      <div class="flex grow items-center justify-end">
        @if (updateAvailable()) {
          <button
            type="button"
            class="text-sm text-primary underline cursor-pointer border-0 bg-transparent p-0 mr-3"
            data-e2e="update-available"
            (click)="reloadForUpdate()"
          >
            Update available - Refresh
          </button>
        }
        <div class="flex flex-col items-end leading-tight text-sm text-muted-color mr-3">
          <span data-e2e="app-version">CloudLinkChat: {{ appVersion }}</span>
          <span data-e2e="chat-lib-version">Library: cloudlink-components-chat {{ chatLibVersion }}</span>
        </div>
        <mi-round-button
          #devToolsBtn
          class="mr-2"
          size="md"
          icon="mi2-wrench"
          tooltipPosition="bottom"
          tooltip="Dev tools"
          ariaLabel="Dev tools"
          data-e2e="dev-tools-trigger"
          (clicked)="openDevToolsMenu()"
        />
        <mi-menu #devToolsMenu [items]="devToolsMenuItems"></mi-menu>
        <mi-round-button
          class="mr-2"
          size="md"
          tooltipPosition="bottom"
          [icon]="themeService.theme() === 'dark' ? 'mi2-light-mode' : 'mi2-dark-mode'"
          [tooltip]="themeService.theme() === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'"
          [ariaLabel]="themeService.theme() === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'"
          data-e2e="theme-toggle"
          (clicked)="themeService.toggle()"
        />
        <button
          #profileMenuBtn
          type="button"
          class="p-0 shadow-none border-0 bg-transparent outline-none rounded-full cursor-pointer focus-visible:shadow-[0px_0px_0px_3px_rgba(0,115,208,0.24)]"
          [attr.aria-haspopup]="true"
          [attr.aria-expanded]="profileMenu.isOpen"
          [attr.aria-label]="claims.name !== 'unknown' ? claims.name : 'Login'"
          data-e2e="profile-menu-trigger"
          (click)="profileMenu.toggle(profileMenuBtn)"
        >
          <mi-avatar
            size="md"
            [name]="claims.name !== 'unknown' ? claims.name : null"
            [initials]="claims.name !== 'unknown' ? (claims.name | initials) : null"
          />
        </button>
        <mi-menu #profileMenu [items]="profileMenuItems"></mi-menu>
        <mi-menu #languageMenu [items]="languageMenuItems"></mi-menu>
      </div>
    </p-toolbar>
  </ng-container>
</mi-layout>
